import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11e44fc3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "toctxt" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "到期前", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "天提醒", -1))
const _hoisted_4 = { class: "bigbox" }
const _hoisted_5 = { class: "box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_7 = { class: "table_sle" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("客服备注")
const _hoisted_10 = {
  key: 0,
  style: {"color":"#ff687b"}
}
const _hoisted_11 = {
  key: 1,
  style: {"color":"#7cbe65"}
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"100%","height":"20px"} }, null, -1))
const _hoisted_16 = { class: "mytooltip" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"100%","height":"20px"} }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "请上传联系商户的截图凭证（如通话记录，聊天记录）", -1))
const _hoisted_21 = { class: "dialog-footer" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("确认")

import { toRaw } from "@vue/reactivity";
import { ref, reactive } from "vue";
import router from "@/router/index";
// import { Plus } from "@element-plus/icons-vue";
// import type { UploadProps } from "element-plus";
import { ElMessage } from "element-plus";
// import { el } from "element-plus/lib/locale";
import type { FormRules, FormInstance } from "element-plus";
import moment from "moment";
import {
  merchantexpireremindremarklist,
  merchantexpireremindlist,
  paymanagementgetall,
  paymanagementupdateconfig,
  paymanagementgetlogs,
  merchantexpireaddremark,
} from "@/api/Merchantapi";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const headerimg = ref("/compontsimg/icon_tx.png");
const headercontent = ref("主要管理商户费用到期的提醒记录统计及客服回访记录");
const gooletil = ref("谷歌验证");
const gooletxt = ref("说明: 本次操作需要验证身份，请向管理员索要谷歌动态口令进行操作");
const BASE_STORE_NUM = ref<any>({});
const BASE_STORE_PRICE = ref<any>({});
const DISCOUNT_PRICE_6 = ref<any>({});
const DISCOUNT_PRICE_12 = ref<any>({});
const DISCOUNT_PRICE_24 = ref<any>({});
const DISCOUNT_PRICE_36 = ref<any>({});
const EXPIRE_REMIND = ref<any>({});
const ruleFormRef = ref<FormInstance>();
const ruleFormType = ref<any>([
  {
    label: "电话",
    value: "mobile",
  },
  {
    label: "信息",
    value: "message",
  },
  {
    label: "面谈",
    value: "interview",
  },
]);
const MyTablelist = ref<any>({
  total: 10,
  pageSize: 10,
  currentPage: 1,
});

const imgViewerVisible = ref(false);
// 图片预览
const imgurl = ref<any>();
const seeImg = (url: any) => {
  imgurl.value = url.visitCredentials;
  imgViewerVisible.value = true;
};

const MyTablelistssm = ref<any>({
  total: 10,
  pageSize: 10,
  currentPage: 1,
});

const ruleForm = ref({
  type: "",
  imageup: "",
  remark: "",
});
const rules = reactive<FormRules>({
  type: [
    {
      required: true,
      message: "请选择联系渠道",
      trigger: "change",
    },
  ],
  imageup: [{ required: true, message: " 请上传联系凭证", trigger: "blur" }],
  remark: [{ required: true, message: " 请输入备注说明", trigger: "blur" }],
});

const changeImg = (val: any) => {
  console.log(val, "上传图片");
  ruleForm.value.imageup = val.fileUrl;
};
const delectImg = (val: string) => {
  ruleForm.value.imageup = val;
};
// 添加备注
const addsmkShow = ref(false);
const merchantIdsss = ref();
const deepseated = (row: any) => {
  merchantIdsss.value = row.id;
  addsmkShow.value = true;
};

const addsmkShowFn = async (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  await formEl.validate((valid: any, fields: any) => {
    if (valid) {
      // gooleshow.value = true;
      merchantexpireaddremark({
        // command: gId,
        remark: ruleForm.value.remark,
        type: ruleForm.value.type,
        visitCredentials: ruleForm.value.imageup,
        merchantId: merchantIdsss.value,
      }).then((res) => {
        if (res.code == 1) {
          ElMessage({
            message: res.msg as string,
            type: "success",
          });
          gooleshow.value = false;
          addsmkShow.value = false;
          submitForm(tablearr);
          ruleForm.value.remark = "";
          ruleForm.value.imageup = "";
          ruleForm.value.type = "";
        } else {
          ElMessage({
            message: res.msg as string,
            type: "warning",
          });
        }
      });
    }
  });
};

const gooleshow = ref(false);
// 添加备注谷歌验证码
const onconfirm = (val: any) => {
  console.log(val);

  let gId = val.ruleForm.gooleId;
  merchantexpireaddremark({
    command: gId,
    remark: ruleForm.value.remark,
    type: ruleForm.value.type,
    visitCredentials: ruleForm.value.imageup,
    merchantId: merchantIdsss.value,
  }).then((res) => {
    if (res.code == 1) {
      ElMessage({
        message: res.msg as string,
        type: "success",
      });
      gooleshow.value = false;
      addsmkShow.value = false;
      submitForm(tablearr);
    } else {
      ElMessage({
        message: res.msg as string,
        type: "error",
      });
    }
  });
  ruleForm.value.remark = "";
  ruleForm.value.imageup = "";
  ruleForm.value.type = "";
};
const canlceAddsmkShow = () => {
  addsmkShow.value = false;
  ruleForm.value.imageup = "";
  ruleForm.value.remark = "";
  ruleForm.value.type = "";
};
const MyTabledata = ref<any>({
  total: 10,
  pageSize: 10,
  currentPage: 1,
});
const sbssmShow = ref(false);
const ffn = () => {
  paymanagementgetall().then((res) => {
    console.log(res, "数据");
    BASE_STORE_NUM.value = res.data[0];
    BASE_STORE_PRICE.value = res.data[1];
    DISCOUNT_PRICE_6.value = res.data[2];
    DISCOUNT_PRICE_12.value = res.data[3];
    DISCOUNT_PRICE_24.value = res.data[4];
    DISCOUNT_PRICE_36.value = res.data[5];
    EXPIRE_REMIND.value = res.data[6];
    num.value = EXPIRE_REMIND.value.ruleValue;
  });
};
ffn();
const tableDatassm = ref<any>();
const eidtShow = ref(false);
const eidtShowdio = ref(false);
const eidtShowFn = () => {
  if (eidtShow.value) {
    eidtShowdio.value = true;
  } else {
    eidtShow.value = !eidtShow.value;
  }
};

const eidtShowdio_save = (val: any) => {
  val.ruleForm.gooleId,
    paymanagementupdateconfig({
      command: val.ruleForm.gooleId,
      dtoList: [
        {
          ruleKey: "EXPIRE_REMIND",
          ruleValue: num.value,
        },
      ],
    }).then((res) => {
      ElMessage({
        message: "操作成功！",
        type: "success",
      });
      eidtShowdio.value = false;
      eidtShow.value = false;
      ffn();
      submitForm(tablearr);
    });
};
const onCloseFn = () => {
  eidtShow.value = false;
  ffn();
};

// 时间戳转日期
const timestampToTime = (timestamp: any) => {
  var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let Y = date.getFullYear() + "-";
  let M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-";
  let D = date.getDate() + " ";
  let h = date.getHours() + ":";
  let m = date.getMinutes() + ":";
  let s = date.getSeconds();
  return Y + M + D + h + m + s;
};
const state = reactive({
  formList: [
    {
      label: "商户全称",
      key: "merchantName",
      type: "input",
      placeholder: "请输入商户全称查询",
      clearable: true,
    },
    {
      label: "商户编号",
      key: "id",
      type: "input",
      placeholder: "请输入商户编号查询",
      clearable: true,
      isNumber: true,
    },

    {
      label: "提醒时间",
      key: "datetime",
      type: "datetimerange",
      endPlaceholder: "结束时间",
      startPlaceholder: "开始时间",
      clearable: true,
    },
  ],
});
const tableData = ref<any>();
const handleChange = (val: any) => {
  console.log(val, "到期提醒");
};
const changeSelect = () => {
  console.log(state);
};

const tablearr = ref<any>({
  endTime: "",
  merchantName: "",
  pageNum: 1,
  pageSize: 10,
  startTime: "",
  id: "",
});
const submitForm = (val: any) => {
  console.log(val.value.merchantName);
  tablearr.value = {
    endTime: "",
    merchantName: val.value.merchantName,
    pageNum: val.value.pageNum || 1,
    pageSize: val.value.pageSize || 10,
    startTime: "",
    merchantId: val.value.id || "",
  };
  if (val.value.datetime && val.value.datetime.length) {
    let list = toRaw(val.value.datetime);
    let endTimes = new Date(list[1]).valueOf() + 24 * 60 * 60 * 1000 - 1;
    let startTimes = new Date(list[0]).valueOf();
    tablearr.value.endTime = endTimes;
    tablearr.value.startTime = startTimes;
  }

  merchantexpireremindlist(tablearr.value).then((res) => {
    console.log(res, "到期提醒");
    tableData.value = res.data.list;
    MyTabledata.value = {
      total: res.data.total,
      pageSize: res.data.pageSize,
      currentPage: res.data.pageNum,
    };
    tableData.value.forEach((item: any) => {
      // item.abortTime = timestampToTime(item.abortTime);
      item.abortTime = moment(item.abortTime).format("YYYY-MM-DD HH:mm:ss");
      // item.remindTime = timestampToTime(item.remindTime);
      item.remindTime = moment(item.remindTime).format("YYYY-MM-DD HH:mm:ss");
    });
  });
};

submitForm(tablearr);
const handleCurrentChange2 = (val: number) => {
  console.log(val, "页码");
  tablearr.value.pageNum = val || 1;
  tablearr.value.pageSize = MyTabledata.value.pageSize;

  submitForm(tablearr);
};
// const handleSizeChange2 = (val: number) => {
//   console.log(val, "页数");
//   tablearr.value.pageSize = val || 10;
//   submitForm(tablearr);
// };
// const handleSizeChange = (val: number) => {
//   console.log(val);
//   MyTablelist.value.pageSize = val;
//   datapar.value = { pageNum: 1, pageSize: val, ruleKeys: ["EXPIRE_REMIND"] };
//   viewrecord();
// };
const handleCurrentChange = (val: number) => {
  console.log(val);
  // MyTablelist.value.pageSize = val;
  datapar.value = { pageNum: val, pageSize: 5, ruleKeys: ["EXPIRE_REMIND"] };
  viewrecord(datapar.value);
};
const Basicstable = ref(false);
const datapar = ref<any>({});
const tableDataBasics = ref<any>([]);
// 变更记录
const viewrecord = (par?: any) => {
  Basicstable.value = true;
  if (par.ruleKeys) {
    datapar.value = par;
  } else {
    datapar.value = { pageNum: 1, pageSize: 5, ruleKeys: ["EXPIRE_REMIND"] };
  }

  paymanagementgetlogs(datapar.value).then((res) => {
    tableDataBasics.value = res.data.list;
    tableDataBasics.value.forEach((item: any) => {
      // item.createTime = timestampToTime(item.createTime);
      item.createTime = moment(item.createTime).format("YYYY-MM-DD HH:mm:ss");
      item.ruleValueOld = Number(item.ruleValueOld).toFixed(0);
    });
    MyTablelist.value = {
      total: res.data.total,
      pageSize: res.data.pageSize,
      currentPage: res.data.pageNum,
    };
  });
};

const tableColumn = ref([
  {
    prop: "merchantName",
    label: "商户全称",
  },
  {
    prop: "abortTime",
    label: "到期时间",
  },
  {
    prop: "remindTime",
    label: "提醒时间",
  },
  {
    prop: "id",
    label: "商户编号",
  },
  {
    prop: "dredgeStoreNum",
    label: "开通门店数量",
  },
  {
    prop: "contactMobile",
    label: "商户电话",
  },

  {
    prop: "userName",
    label: "销售负责人",
  },
  {
    slotName: "merchantStatus",
  },
  {
    slotName: "isHaveRemark",
  },
  {
    slotName: "slotName",
  },
]);

const toAddmerchant = () => {
  router.push("/Merchantmanagement/Newmerchants");
};
const num = ref(1);

const imageUrl = ref("");

const sbssmpar = ref<any>();

const sbFx = (par: any) => {
  merchantexpireremindremarklist(par).then((res) => {
    console.log(res.data, "备注详情");
    tableDatassm.value = res.data.list;
    tableDatassm.value.forEach((item: any) => {
      // item.createTime = timestampToTime(item.createTime);
      item.createTime = moment(item.createTime).format("YYYY-MM-DD HH:mm:ss");
    });
    MyTablelistssm.value = {
      total: res.data.total,
      pageSize: res.data.pageSize,
      currentPage: res.data.pageNum,
    };
  });
};

const sbssmFn = (row: any) => {
  sbssmShow.value = true;
  sbssmpar.value = { merchantId: row.id, pageNum: 1, pageSize: 5 };
  sbFx(sbssmpar.value);
};

const handleCurrentChange3 = (val: number) => {
  console.log(val, "页码");
  sbssmpar.value.pageNum = val || 1;
  sbssmpar.value.pageSize = MyTablelistssm.value.pageSize;
  sbFx(sbssmpar.value);
};
const handleSizeChange3 = (val: number) => {
  console.log(val, "页数");
  sbssmpar.value.pageSize = val || 10;
  sbFx(sbssmpar.value);
};

const tableColumn2 = ref([
  {
    prop: "ruleName",
    label: "类型",
    // width: "120px",
  },
  {
    prop: "ruleValueNew",
    label: "变更后数据",
    // width: "300px",
  },
  {
    prop: "ruleValueOld",
    label: "原始数据",
    // width: "300px",
  },
  {
    prop: "createTime",
    label: "变更时间",
    // width: "180px",
  },
  {
    prop: "updateAcc",
    label: "操作账号",
    // width: "120px",
  },
]);

const tableColumn3 = ref([
  {
    slotName: "type",
  },
  {
    slotName: "visitCredentials",
  },
  {
    slotName: "remark",
    // width: "300px",
  },
  {
    prop: "createTime",
    label: "操作时间",
    // width: "180px",
  },
  {
    prop: "userAccount",
    label: "操作账号",
    // width: "120px",
  },
]);

return (_ctx: any,_cache: any) => {
  const _component_Pageheader = _resolveComponent("Pageheader")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Publicform = _resolveComponent("Publicform")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_MyTable = _resolveComponent("MyTable")!
  const _component_GoogleDialogue = _resolveComponent("GoogleDialogue")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_MyUpload = _resolveComponent("MyUpload")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_image_viewer = _resolveComponent("el-image-viewer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Pageheader, {
      title: "到期提醒",
      img: headerimg.value,
      text: headercontent.value
    }, null, 8, ["img", "text"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_el_input_number, {
        class: "numinput",
        controls: false,
        modelValue: num.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((num).value = $event)),
        min: 1,
        max: 100000,
        onChange: handleChange,
        disabled: !eidtShow.value
      }, null, 8, ["modelValue", "disabled"]),
      _hoisted_3,
      _createVNode(_component_el_button, {
        style: {"width":"60px","height":"26px"},
        class: "button",
        type: "primary",
        onClick: eidtShowFn,
        round: ""
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(eidtShow.value ? "保存" : "编辑"), 1)
        ]),
        _: 1
      }),
      _createElementVNode("span", {
        class: "righttxt",
        onClick: viewrecord
      }, "变更记录")
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Publicform, {
          formList: state.formList,
          ref: "addAndEditDom",
          onChangeSelect: changeSelect,
          onSubmitForm: submitForm
        }, {
          from: _withCtx(() => []),
          _: 1
        }, 8, ["formList"]),
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_MyTable, {
            tableData: tableData.value,
            isHeight: false,
            onHandleCurrentChange: handleCurrentChange2,
            onHandleSizeChange: _ctx.handleSizeChange2,
            total: MyTabledata.value.total,
            pageSize: MyTabledata.value.pageSize,
            currentPage: MyTabledata.value.currentPage,
            ifselection: false,
            isPagination: true,
            isIndex: true,
            tableColumn: tableColumn.value
          }, {
            slotName: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "操作",
                align: "center"
              }, {
                default: _withCtx(({ row }) => [
                  false
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(row), 1))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: ($event: any) => (deepseated(row)),
                    round: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              })
            ]),
            merchantStatus: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "当前账户状态",
                align: "center"
              }, {
                default: _withCtx(({ row }) => [
                  (row.merchantStatus == '01')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, "已到期"))
                    : _createCommentVNode("", true),
                  (row.merchantStatus == '02')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, "待续费"))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            isHaveRemark: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "备注记录",
                align: "center"
              }, {
                default: _withCtx(({ row }) => [
                  (row.isHaveRemark)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "sb_ssm",
                        onClick: ($event: any) => (sbssmFn(row))
                      }, "查看详情", 8, _hoisted_12))
                    : (_openBlock(), _createElementBlock("span", _hoisted_13, "--"))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["tableData", "onHandleSizeChange", "total", "pageSize", "currentPage", "tableColumn"])
        ])
      ])
    ]),
    _createVNode(_component_GoogleDialogue, {
      title: gooletil.value,
      text: gooletxt.value,
      dialogVisible: eidtShowdio.value,
      "onUpdate:dialogVisible": _cache[1] || (_cache[1] = ($event: any) => ((eidtShowdio).value = $event)),
      onChangeNavfu: eidtShowdio_save,
      onOnCloseFn: onCloseFn
    }, null, 8, ["title", "text", "dialogVisible"]),
    _createVNode(_component_el_dialog, {
      modelValue: Basicstable.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((Basicstable).value = $event)),
      title: "查看变更记录",
      width: "70%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_MyTable, {
          tableData: tableDataBasics.value,
          ifselection: false,
          isPagination: true,
          isHeight: false,
          isIndex: true,
          tableColumn: tableColumn2.value,
          onHandleCurrentChange: handleCurrentChange,
          onHandleSizeChange: _ctx.handleSizeChange,
          total: MyTablelist.value.total,
          pageSize: MyTablelist.value.pageSize,
          currentPage: MyTablelist.value.currentPage
        }, {
          slotName: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "操作",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                false
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(row), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["tableData", "tableColumn", "onHandleSizeChange", "total", "pageSize", "currentPage"]),
        _hoisted_15
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: sbssmShow.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((sbssmShow).value = $event)),
      title: "备注记录-查看详情",
      width: "70%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_MyTable, {
          tableData: tableDatassm.value,
          ifselection: false,
          isPagination: true,
          isIndex: true,
          isHeight: false,
          tableColumn: tableColumn3.value,
          onHandleCurrentChange: handleCurrentChange3,
          onHandleSizeChange: handleSizeChange3,
          total: MyTablelistssm.value.total,
          pageSize: MyTablelistssm.value.pageSize,
          currentPage: MyTablelistssm.value.currentPage
        }, {
          remark: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "备注说明",
              width: "150",
              align: "left"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_tooltip, {
                  content: row.remark,
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_16, _toDisplayString(row.remark), 1)
                  ]),
                  _: 2
                }, 1032, ["content"])
              ]),
              _: 1
            })
          ]),
          type: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "联系渠道",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", null, _toDisplayString(row.type == "mobile" ? "电话" : row.type == "message" ? "信息" : "面谈"), 1)
              ]),
              _: 1
            })
          ]),
          visitCredentials: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "联系凭证",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                (row.visitCredentials)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "sb_ssm",
                      onClick: ($event: any) => (seeImg(row))
                    }, "查看", 8, _hoisted_17))
                  : (_openBlock(), _createElementBlock("span", _hoisted_18, "--"))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["tableData", "tableColumn", "total", "pageSize", "currentPage"]),
        _hoisted_19
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: addsmkShow.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((addsmkShow).value = $event)),
      title: "添加备注",
      width: "500px"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_21, [
          _createVNode(_component_el_button, {
            onClick: canlceAddsmkShow,
            class: "cancelBtn"
          }, {
            default: _withCtx(() => [
              _hoisted_22
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (addsmkShowFn(ruleFormRef.value)))
          }, {
            default: _withCtx(() => [
              _hoisted_23
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          model: ruleForm.value,
          rules: rules,
          "label-width": "80px",
          class: "demo-ruleForm"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "联系渠道",
              prop: "type"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  style: {"width":"100%"},
                  modelValue: ruleForm.value.type,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((ruleForm.value.type) = $event)),
                  placeholder: "请选择联系渠道"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ruleFormType.value, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "联系凭证",
              prop: "imageup"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_MyUpload, {
                    modelValue: ruleForm.value.imageup,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((ruleForm.value.imageup) = $event)),
                    imageUrl: ruleForm.value.imageup,
                    tipText: "",
                    onChangeImg: changeImg,
                    onDelectImg: delectImg
                  }, null, 8, ["modelValue", "imageUrl"]),
                  _hoisted_20
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "备注说明",
              prop: "remark"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  rows: 6,
                  placeholder: "请输入内容",
                  maxlength: "100",
                  modelValue: ruleForm.value.remark,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((ruleForm.value.remark) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_GoogleDialogue, {
      title: gooletil.value,
      text: gooletxt.value,
      dialogVisible: gooleshow.value,
      "onUpdate:dialogVisible": _cache[9] || (_cache[9] = ($event: any) => ((gooleshow).value = $event)),
      onChangeNavfu: onconfirm
    }, null, 8, ["title", "text", "dialogVisible"]),
    (imgViewerVisible.value)
      ? (_openBlock(), _createBlock(_component_el_image_viewer, {
          key: 0,
          "url-list": [imgurl.value],
          onClose: _cache[10] || (_cache[10] = ($event: any) => (imgViewerVisible.value = false))
        }, null, 8, ["url-list"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})